import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Truck, RefreshCw, Shield, Star } from 'lucide-react';

const trustItems = [
    { icon: Truck, title: 'FREE SHIPPING', desc: 'On all orders above ₹999' },
    { icon: RefreshCw, title: 'EASY RETURNS', desc: '15-day hassle-free returns' },
    { icon: Shield, title: 'SECURE PAYMENT', desc: '100% protected checkout' },
    { icon: Star, title: '50K+ HAPPY FITS', desc: 'Rated 4.8 by our community' },
];

export const TrustBadges = () => {
    return (
        <section className="border-y border-border py-12 md:py-16" data-testid="trust-section">
            <div className="max-w-[1400px] mx-auto px-4 md:px-8">
                <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
                    {trustItems.map((item, index) => (
                        <motion.div
                            key={item.title}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ delay: index * 0.1 }}
                            className="text-center"
                        >
                            <item.icon className="w-8 h-8 mx-auto mb-3 text-lime" />
                            <h3 className="font-heading text-sm tracking-[0.06em] mb-1">{item.title}</h3>
                            <p className="text-xs text-muted-foreground">{item.desc}</p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export const Offers = () => {
    return (
        <section className="py-16 md:py-24" data-testid="offers-section">
            <div className="max-w-[1400px] mx-auto px-4 md:px-8">
                {/* Header */}
                <div className="mb-8 md:mb-12">
                    <span className="text-xs tracking-[0.2em] uppercase text-muted-foreground mb-2 block">
                        DEALS
                    </span>
                    <h2 className="font-heading text-4xl md:text-6xl">
                        BIGGER<br />SAVINGS
                    </h2>
                </div>

                {/* Offer Cards */}
                <div className="grid md:grid-cols-2 gap-3">
                    {/* Card 1 */}
                    <motion.div
                        initial={{ opacity: 0, x: -20 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                        className="relative bg-lime text-black p-8 md:p-10 overflow-hidden"
                    >
                        <div className="absolute -bottom-10 -right-10 w-40 h-40 border border-black/15 rounded-full" />
                        <span className="text-xs font-bold tracking-[0.18em] uppercase opacity-70 block mb-3">
                            LIMITED TIME OFFER
                        </span>
                        <h3 className="font-heading text-5xl md:text-6xl lg:text-7xl leading-[0.9] mb-4">
                            BUY 2<br />GET<br />20% OFF
                        </h3>
                        <span className="inline-block bg-black/15 px-4 py-2 text-xs font-bold tracking-[0.18em] uppercase mb-6">
                            USE CODE: CHILL20
                        </span>
                        <br />
                        <Link
                            to="/products"
                            className="inline-block bg-black text-lime px-6 py-3 text-xs font-bold tracking-[0.14em] uppercase hover:bg-black/90 transition-colors"
                            data-testid="offer-1-btn"
                        >
                            SHOP NOW
                        </Link>
                    </motion.div>

                    {/* Card 2 */}
                    <motion.div
                        initial={{ opacity: 0, x: 20 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                        className="relative bg-card border border-border p-8 md:p-10 overflow-hidden"
                    >
                        <div className="absolute -top-5 right-5 w-20 h-20 border border-lime/20 rounded-full" />
                        <span className="text-xs font-bold tracking-[0.18em] uppercase text-muted-foreground block mb-3">
                            MEGA BUNDLE
                        </span>
                        <h3 className="font-heading text-5xl md:text-6xl lg:text-7xl leading-[0.9] mb-4">
                            BUY 3<br />GET<br />30% OFF
                        </h3>
                        <span className="inline-block bg-lime/10 text-lime px-4 py-2 text-xs font-bold tracking-[0.18em] uppercase mb-6">
                            USE CODE: CHILL30
                        </span>
                        <br />
                        <Link
                            to="/products"
                            className="inline-block bg-lime text-black px-6 py-3 text-xs font-bold tracking-[0.14em] uppercase hover:bg-lime/90 transition-colors"
                            data-testid="offer-2-btn"
                        >
                            SHOP NOW
                        </Link>
                    </motion.div>
                </div>
            </div>
        </section>
    );
};
